module.exports = __webpack_public_path__ + "img/preview_position.c4f3fcb2.png";